import { render, staticRenderFns } from "./DocumentsPlanet.vue?vue&type=template&id=c875601e"
import script from "./DocumentsPlanet.vue?vue&type=script&lang=js"
export * from "./DocumentsPlanet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports